//@flow
import React from 'react'
import {CircularProgress} from '@hiver/hiver-ui-kit'
import { Button } from './styledComponents'

const style = {
    color: '#fff'
}
const CTAButton  = ({ isLoading, children, loaderSize, ...rest }: Props) => {
    return <Button {...rest}>
        { isLoading ? <CircularProgress style={style} size={loaderSize||30} /> : children}       
    </Button>
}   

type Props = {
    isLoading: boolean,
    children: Array<any>,
    loaderSize: number
}

export default CTAButton
